// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__k_X9D","modalFooterButton":"ModalNotes_modalFooterButton__2WSc7"};